var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 178.109 161.291"}},_vm.$listeners),[_c('path',{attrs:{"d":"M178.109 55.856v105.435h-38.818V77.345l-50.236-31.56-50.235 31.56v83.946H0V55.856L88.951 0l89.158 55.856z","fill":"#e94357"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }